import React from 'react';
import { Outlet } from 'react-router-dom';

import '../../Mobile.css';

function User() {

  return (
    <>
      <Outlet />
    </>
  );
}

export default User